import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import React from "react";

export default function SelectCustom(params) {
  return (
    <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-end"} spacing={2}>
      <Typography  align="left" variant="subtitle1" fontWeight={"bold"}>
        {params.required && "*" + params.title}
      </Typography>
      <Select 
        required={params.required}
        variant="outlined"
        name={params.name}
        id={params.id}
        value={params.value}
        onChange={params.onChange}
        sx={{
          width: "90%",

          "& .MuiSelect-outlined": {
            padding: 1,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: 2, // Change border radius
            borderColor: "green", // Change border color
            borderWidth: 1, // Change border width
          },
          // Target hover state
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "blue",
          },
          // Target focused state
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "blue",
            borderWidth: "3px",
          },
        }}
      >
        {params.options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
}
